import React from 'react';
import { profilePersonalInfoPage } from 'platform/forms-system/src/js/patterns/prefill';

const personalInfoPageConfig = {
  key: 'applicantInformation',
  title: 'Applicant information',
  path: 'applicant/information',
  depends: formData => formData?.claimantType === 'VETERAN',
  dataAdapter: {
    ssnPath: 'claimantSocialSecurityNumber',
    vaFileNumberPath: 'vaFileNumberLastFour',
  },
};

const personalInfoConfig = {
  name: { show: true, required: true },
  ssn: { show: true, required: false },
  vaFileNumber: { show: true, required: false },
  dateOfBirth: { show: true, required: true },
};
const { applicantInformation: applicantInformationWithVaFileNumber } =
  profilePersonalInfoPage({
    ...personalInfoPageConfig,
    personalInfoConfig,
  });

const { applicantInformation: applicantInformationWithoutVaFileNumber } =
  profilePersonalInfoPage({
    ...personalInfoPageConfig,
    personalInfoConfig: {
      ...personalInfoConfig,
      vaFileNumber: { show: false, required: false },
    },
  });
export const hasVaFileNumber = formData =>
  !!(formData?.veteranVaFileNumberLastFour || formData?.vaFileNumber);
const getApplicantInformationPage = formData =>
  hasVaFileNumber(formData)
    ? applicantInformationWithVaFileNumber
    : applicantInformationWithoutVaFileNumber;

export const ApplicantInformationPage = props => {
  const { CustomPage } = getApplicantInformationPage(props.data);
  return <CustomPage {...props} />;
};

export const ApplicantInformationReview = props => {
  const { CustomPageReview } = getApplicantInformationPage(props.data);
  return <CustomPageReview {...props} />;
};
/** @type {PageSchema} */
export default {
  ...applicantInformationWithVaFileNumber,
  CustomPage: ApplicantInformationPage,
  CustomPageReview: ApplicantInformationReview,
};
